/***

* @param func 输入完成的回调函数

* @param delay 延迟时间

*/

export function debounce(func, delay) {
    let timer

    return function(...args) {
        if (timer) {
            clearTimeout(timer)
        }
        const context = this
        timer = setTimeout(() => {
            func.apply(context, args)
        }, delay)
    }
}



// WEBPACK FOOTER //
// ./src/utils/debounce.js